import extractDomain from 'extract-domain';

export default class Website {
  static getDomain(website){
    let url = Website.getCustomDomain(website) || Website.getNativeDomain(website)
    return url
  }

  static getCustomDomain(website){
    if(!website.url){
      return null
    }

    if(website.url.startsWith("http://") || website.url.startsWith("https://")){
      return website.url
    }
    return "http://" + website.url
  }

  static getNativeDomain(website){
    return "https://" + window.General.WebsiteNakedDomain
  }

  static getCleanDomain(website){
    let url = Website.getDomain(website)
    url = url.replace("https://", "").replace("http://", "")
    return url
  }

  static getDashboardUrl(website){
    if(website.url){
      return window.General.ClientDashboardUrl
    }
    return Website.getRelativeUrl(website, "dashboard")
  }

  static getCleanDomain(website){
    let url = Website.getDomain(website)
    url = url.replace("https://", "").replace("http://", "")
    return url
  }

  static getRelativeUrl(website, subdomain){
    let url = window.location.hostname
    let domain = extractDomain(url, { tld: true }) || url;

    if (url.indexOf("localhost") === -1) {
      return `https://${subdomain}.${domain}`
    } else {
      return window.General.ClientDashboardUrl
    }
  }

  static hasFunnelReference(){
    let websiteUrl = window.location.host;

    return  websiteUrl.indexOf("store-front.dev") > -1 ||
      websiteUrl.indexOf("storefront.checkoutchamp.com") > -1 ||
      websiteUrl.indexOf("funnels-build.thisisatestsiteonly.com") > -1 ||
      websiteUrl.indexOf("funnels.thisisatestsiteonly.com") > -1
  }

  static removeCCLink(websiteData, type, pageId, urls){
    if(!websiteData?.extra?.ccPageLinks){
      return websiteData
    }

    const urlCountMap = urls.reduce((acc, url) => {
      acc[url] = (acc[url] || 0) + 1;
      return acc;
    }, {});

    if(type === "pages"){
      let page = websiteData.extra.ccPageLinks.pages.find(page => page.id === pageId)
      if(!page) return websiteData;

      page.links = page.links.map(link => (urls.includes(link.url) ? {...link, count: link.count - urlCountMap[link.url] } : link)).filter(link => link.count > 0)

      if(page.links.length === 0){
        websiteData.extra.ccPageLinks.pages = websiteData.extra.ccPageLinks.pages.filter(page => page.id !== pageId)
      }
    }else{
      let typeLinks = websiteData.extra.ccPageLinks[type]
      websiteData.extra.ccPageLinks[type] = typeLinks.map(link => (urls.includes(link.url) ? {...link, count: link.count - urlCountMap[link.url] } : link)).filter(link => link.count > 0)
    }

    return websiteData
  }

  static addCCLink(websiteData, type, pageId, newLink){
    if(type === "pages"){
      let page = websiteData.extra.ccPageLinks.pages.find(page => page.id === pageId)
      if(!page){
        page = {id: pageId, links: []}
        websiteData.extra.ccPageLinks.pages.push(page)
      }
      let existingLink = page.links.find(link => link.id === newLink.id)
      if(existingLink){
        existingLink.count++
      }else{
        page.links.push({...newLink, count: 1})
      }
    }else{
      let typeLinks = websiteData.extra.ccPageLinks[type]
      let existingLink = typeLinks.find(link => link.id === newLink.id)
      if(existingLink){
        existingLink.count++
      }else{
        typeLinks.push({...newLink, count: 1})
      }
    }

    return websiteData
  }

  static deletePage(websiteData, pageId){
    if(!websiteData?.extra?.ccPageLinks){
      return websiteData
    }

    let page = websiteData.extra.ccPageLinks.pages.find(page => page.id === pageId)
    if(!page) return websiteData;

    const urlCountMap = page.links.reduce((acc, url) => {
      acc[url] = (acc[url] || 0) + 1;
      return acc;
    }, {});

    websiteData.extra.ccPageLinks.pages = websiteData.extra.ccPageLinks.pages.filter(p => p.id !== pageId);

    return websiteData
  }

  static getCCPageIds(websiteData){
    const linkIds = new Set()

    if(websiteData?.extra?.ccPageLinks){
      websiteData.extra.ccPageLinks.menu.forEach(link => linkIds.add(link.id))
      websiteData.extra.ccPageLinks.footer.forEach(link => linkIds.add(link.id))
      websiteData.extra.ccPageLinks.shop.forEach(link => linkIds.add(link.id))

      websiteData.extra.ccPageLinks.pages.forEach(page => {
        page.links.forEach(link => linkIds.add(link.id));
      });
    }

    return Array.from(linkIds);
  }

  static getUrls(obj){
    let links = [];

    if (typeof obj !== "object" || obj === null) return [];

    Object.keys(obj).forEach(key => {
      if(Array.isArray(obj[key])){
        obj[key].forEach((item) => {
          links.push(...Website.getUrls(item))
        })
      }else if (typeof obj[key] === 'object') {
        links.push(...Website.getUrls(obj[key]));
      }else if(key === "url"){
        links.push(obj[key])
      }

    });

    return links
  }
}
